<template>
  <svg
    :viewBox="iconData.viewBox"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    class="fa-icon"
    v-html="iconData.inner"
  ></svg>
</template>

<script>
import { faIconData } from '@/assets/fa-icons.js'

export default {
  name: 'FaIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconData() {
      return faIconData[this.icon] || { viewBox: '0 0 512 512', inner: '' }
    },
  },
}
</script>

<style scoped>
.fa-icon {
  display: inline-block;
  height: 1em;
  width: auto;
  vertical-align: -0.125em;
  fill: currentColor;
  overflow: visible;
}
</style>
